import React from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import {
  ProjectStatusDetailStatus,
  ProjectStatusEndorsement,
  ProjectStatusExpandedDetails,
} from "../../types";

const ProjectStatusDetailValue: React.FC<{
  status: ProjectStatusDetailStatus;
}> = ({ status }) => {
  if (status.variant === "completed") {
    return (
      <span className="project-status-detail-bar__status project-status-detail-bar__status--completed">
        <Iconography
          icon="circleCheck"
          size={IconographySizes.Small}
          className="project-status-detail-bar__status-icon"
          aria-hidden
        />
        <span>{status.label}</span>
      </span>
    );
  }

  return (
    <span
      className={`project-status-detail-bar__status project-status-detail-bar__status--${status.variant}`}
    >
      {status.label}
    </span>
  );
};

const ProjectStatusEndorsementBadge: React.FC<{
  endorsement: ProjectStatusEndorsement;
}> = ({ endorsement }) => {
  if (endorsement.variant === "neutral") {
    return <span className="project-status-detail-bar__dash">{endorsement.label}</span>;
  }

  return (
    <span
      className={`project-status-detail-bar__endorsement project-status-detail-bar__endorsement--${endorsement.variant}`}
    >
      {endorsement.label}
    </span>
  );
};

const ProjectStatusDetailBar: React.FC<{
  details: ProjectStatusExpandedDetails;
}> = ({ details }) => (
  <div className="project-status-detail-bar">
    <div className="project-status-detail-bar__section project-status-detail-bar__section--integration">
      <span className="project-status-detail-bar__label">Integration Status</span>
      <div className="project-status-detail-bar__value-row">
        <ProjectStatusDetailValue status={details.integrationStatus} />
        <span className="project-status-detail-bar__age">
          <span className="project-status-detail-bar__age-label">Age:</span>
          <span className="project-status-detail-bar__age-value">{details.age}</span>
        </span>
      </div>
    </div>

    <span className="project-status-detail-bar__divider" aria-hidden />

    <div className="project-status-detail-bar__section project-status-detail-bar__section--validation">
      <span className="project-status-detail-bar__label">Validation Status</span>
      <div className="project-status-detail-bar__value-row">
        <ProjectStatusDetailValue status={details.validationStatus} />
      </div>
    </div>

    <span className="project-status-detail-bar__divider" aria-hidden />

    <div className="project-status-detail-bar__section project-status-detail-bar__section--endorsement">
      <span className="project-status-detail-bar__label">Endorsement</span>
      <div className="project-status-detail-bar__value-row">
        <ProjectStatusEndorsementBadge endorsement={details.endorsement} />
      </div>
    </div>

    <span className="project-status-detail-bar__divider" aria-hidden />

    <div className="project-status-detail-bar__section project-status-detail-bar__section--score">
      <span className="project-status-detail-bar__label">Score</span>
      <div className="project-status-detail-bar__value-row">
        <span className="project-status-detail-bar__score">{details.score}</span>
      </div>
    </div>
  </div>
);

export default ProjectStatusDetailBar;
